<div class="row">

  <div class="col-lg-6">
    <h3>Contact Information</h3>
  </div>

  <div class="col-lg-6">
    @if (isEditMode) {
      <button type="button"
        class="btn btn-primary btn-wrap pull-right"
        [disabled]="contactInformationForm.invalid"
        (click)="save()">
        Update
      </button>
    }
    @if (!isEditMode) {
      <button type="button"
        class="btn btn-primary btn-wrap pull-right"
        (click)="toggleEdit()">
        Edit
      </button>
    }
    @if (isEditMode) {
      <button type="button"
        class="btn btn-default btn-wrap pull-right"
        (click)="toggleEdit()">
        Close
      </button>
    }
  </div>

</div>

@if (!isEditMode) {
  <div>
    <table class="table table-striped">
      <tbody>
        @for (field of FIELDS; track field) {
          <tr>
            <td width="250px">{{field.label}}</td>
            <td>{{formData[field.name]}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (isEditMode) {
  <div>
    <form class="form" [formGroup]="contactInformationForm" novalidate>
      <table class="table table-striped">
        <tbody>
          @for (field of FIELDS; track field) {
            <tr>
              <td width="250px">{{field.label}}</td>
              <td>
                @switch (field.type) {
                  @case ('dropdown') {
                    <dropdown
                      [options]="field.options"
                      formControlName={{field.name}}>
                    </dropdown>
                  }
                  @case ('text') {
                    <input
                      type={{field.type}}
                      class="form-control"
                      formControlName={{field.name}}
                      placeholder={{field.label}}>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </form>
  </div>
}
